"use client";

import { Image as ImageType } from "@/types/Image";
import Image from "next/image";
import { useState } from "react";
import AlbumCarouselModal from "../AlbumModal/AlbumCarouselModal";
import "./index.scss";

const ImageGridBento = ({ images }: { images: ImageType[] }) => {
  const [showAlbumCarouselModal, setShowAlbumCarouselModal] = useState(false);
  const [albumCarouselModalImageIndex, setAlbumCarouselModalImageIndex] =
    useState(0);

  const imageNodes = images.map((image, imageIndex) => {
    return (
      <div className="image-container" key={image.src}>
        <a
          onClick={() => {
            setAlbumCarouselModalImageIndex(imageIndex);
            setShowAlbumCarouselModal(true);
          }}
        >
          <Image
            src={image.src}
            alt={image.alt}
            fill={true}
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
        </a>
      </div>
    );
  });

  return (
    <div className="component image-grid-bento">
      <div className="image-grid-bento-inner-wrapper">
        <div className="image-grid-bento-inner-wrapper-2">{imageNodes}</div>
      </div>
      {showAlbumCarouselModal && (
        <AlbumCarouselModal
          images={images}
          initialImageIndex={albumCarouselModalImageIndex}
          onClose={() => setShowAlbumCarouselModal(false)}
        />
      )}
    </div>
  );
};

export default ImageGridBento;
